import { mediaQueryUp } from 'components/utils/breakpoint'
import { css } from 'styled-components'
import config from 'constants/config'
import { generateCSSVarEntries, getThemeClassName } from 'lib/theme/themeUtils'

const DefaultStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.defaultPalette, 'palette')))
const InverseStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.inversePalette, 'palette')))
const BorderRadiiStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.borderRadius, 'border-radius')))
const ShadowsStyle = css(Object.fromEntries(generateCSSVarEntries(config.theme.shadows, 'shadow')))

const ThemeStyles = css`
  :root {
    ${BorderRadiiStyle}
    ${ShadowsStyle}
  }
  :root,
  .${getThemeClassName({ mobile: 'default' })} {
    ${DefaultStyle}
    color: ${props => props.theme.palette.neutral.surface.normalContrast};
  }
  .${getThemeClassName({ mobile: 'inverse' })} {
    ${InverseStyle}
    color: ${props => props.theme.palette.neutral.surface.normalContrast};
  }
  ${mediaQueryUp.tablet} {
    .${getThemeClassName({ tablet: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
    .${getThemeClassName({ tablet: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
  }
  ${mediaQueryUp.desktop} {
    .${getThemeClassName({ desktop: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
    .${getThemeClassName({ desktop: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
  }
  ${mediaQueryUp.largeDesktop} {
    .${getThemeClassName({ largeDesktop: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
    .${getThemeClassName({ largeDesktop: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
  }
  ${mediaQueryUp.extraLargeDesktop} {
    .${getThemeClassName({ extraLargeDesktop: 'default' })} {
      ${DefaultStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
    .${getThemeClassName({ extraLargeDesktop: 'inverse' })} {
      ${InverseStyle}
      color: ${props => props.theme.palette.neutral.surface.normalContrast};
    }
  }
`

export default ThemeStyles
